import {ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {NgRedux, select} from '@angular-redux/store';
import {combineLatest, Observable, Subscription} from 'rxjs';
import {
  CollectionsByPayerGroupedByLevel,
  CollectionsData,
  MatchedCollectionsByMultiLevelByNodePath,
  PayerByMultiLevelCollectionsByNodePath,
  PayerCollections,
  PayerDrilldownCriteria,
  PayerMatchedCollectionsMultiLevelNodePathData
} from '../../Collection';
import {BaseColumn, IAppState, INITIAL_STATE} from '../../../store/IAppState';
import {BenchmarkType} from '../../../shared/benchmark-types';
import {canHide, getLevel, LevelType, Page} from '../../../shared/helpers';
import {
  AppAction, collectionsChargeDisplayedChangedTo, expectedPaymentsDisplayedChangedTo,
  filterCriteriaChangedTo,
  multiLevelByNodePathPayerCollectionsColumnsChangedTo,
  multilevelPayerCollectionsChangedTo,
  payerByLevelCollectionsPayerColumnsChangedTo,
  payerCollectionsDataChangedTo,
  snapshotPayerCollectionsColumnsChangedTo
} from '../../../store/actions';
import {
  columnsForMultiLevelPayerCollectionsDepartment,
  columnsForMultiLevelPayerCollectionsProvider,
  columnsForMultiLevelPayerCollectionsSpecialty,
  columnsForPayerByMultiLevelCollections,
  columnsForPayerCollections,
  DataTableColumns
} from '../../../shared/data-table-columns';
import * as _ from 'lodash';
import {ColumnType, MultilevelTabCollections, PayerType} from '../../../shared/enums';
import {Router} from '@angular/router';
import {AnalyticsService, AnalyticsServiceToken} from '../../../analytics/analytics.service';
import {distinctUntilChanged} from 'rxjs/operators';
import {FeatureToggleEntries} from '../../../shared/feature-toggle-settings-enum';
import {
  createCollectionsVarianceColumnFor,
  createNCRBenchmarkColumnFor,
  createPayerNCRBenchmarkColumnFor
} from '../../../shared/BenchmarkColumns';
import {DisplayField, Variable} from "../../../variable-container/variable-container.component";

@Component({
  selector: 'app-payer-collections-multilevel',
  templateUrl: './payer-collections-multilevel.component.html',
  styleUrls: ['./payer-collections-multilevel.component.scss']
})
export class PayerCollectionsMultilevelComponent implements OnInit, OnDestroy {

  @select(['data', 'payerCollectionsData', 'payerMatchedCollections'])
  private readonly payerCollectionsData$: Observable<PayerCollections[]>;

  @select(['data', 'matchedCollectionsByPayerByMultiLevelByNodePathData'])
  private readonly payerByMultiLevelCollectionsData$: Observable<PayerMatchedCollectionsMultiLevelNodePathData>;

  @select(['display', 'payerByLevelCollectionsPayerColumns'])
  private readonly payerByLevelPayerColumns$: Observable<BaseColumn[]>;

  @select(['display', 'multiLevelByNodePathPayerCollectionsColumns'])
  private readonly multiLevelByNodePathPayerCollectionsColumns$: Observable<BaseColumn[]>;

  @select(['display', 'payerByLevelCollectionsStaticColumns'])
  private readonly payerByLevelStaticColumns$: Observable<BaseColumn[]>;

  @select(['benchmark'])
  private readonly benchmarkType$: Observable<BenchmarkType>;

  @select(['display', 'displayedPayerCollectionsColumns'])
  private readonly displayedPayerCollectionsColumns$: Observable<BaseColumn[]>;

  @select(['display', 'zeroSuppression'])
  private readonly zeroSuppression$: Observable<boolean>;

  subscription: Subscription;
  collectionsData: CollectionsData[];
  payerCollectionsData: PayerCollections[] = [];
  payerByMultiLevelCollectionsData: PayerMatchedCollectionsMultiLevelNodePathData = {
    departmentCollections: [], specialtyCollections: [], providerCollections: []
  };
  departmentPayerCollectionsData: MatchedCollectionsByMultiLevelByNodePath[] = [];
  specialtyPayerCollectionsData: MatchedCollectionsByMultiLevelByNodePath[] = [];
  providerPayerCollectionsData: MatchedCollectionsByMultiLevelByNodePath [] = [];
  level: string;
  defaultSortColumn: string;
  isProvider = false;
  showProgressBar: boolean;
  showProgressBarMultiLevel: boolean;
  canHideScrollable: boolean;
  columnHeaders: BaseColumn[];
  viewCommunityBenchmarks: boolean;
  defaultBenchmarkType = BenchmarkType.Percentile50th;
  benchmarkType: BenchmarkType = this.defaultBenchmarkType;
  currentPage = Page.CollectionsByPayer;
  payerLevel: string;
  hasPayers = false;
  isZeroSuppressed = false;
  howManyProvidersSuppressed = 0;
  readonly zeroSuppressTooltip = 'When zero suppression is applied, only \'node levels\' with reported' +
    ' collections data will be displayed.  The \'node\'  suppressed will be hidden from both the data table and the graph.  ';
  snapshotPayerCollectionsColumnsChangedTo = snapshotPayerCollectionsColumnsChangedTo;
  openWindowColumns: DataTableColumns[] = [];
  scrollableColumns: DataTableColumns[] = [];
  scrollableMultiLevelColumns: DataTableColumns[] = [];
  payerStaticColumns: BaseColumn[];
  payerByLevelPayerColumns: BaseColumn[];
  providerColumns = _.cloneDeep(columnsForMultiLevelPayerCollectionsProvider);
  displayedProviderColumns: DataTableColumns[] = [];
  specialtyColumns = _.cloneDeep(columnsForMultiLevelPayerCollectionsSpecialty);
  displayedSpecialtyColumns: DataTableColumns[] = [];
  departmentColumns = _.cloneDeep(columnsForMultiLevelPayerCollectionsDepartment);
  displayedDepartmentColumns: DataTableColumns[] = [];
  columnSubscription: Subscription;
  chosenTab: MultilevelTabCollections;
  MultilevelTabCollections = MultilevelTabCollections;
  originalByLevelColumns: DataTableColumns[] = [];
  nodePath: string;
  canHideDenials = true;

  displayedByLevelColumns: DataTableColumns[] = [];

  variables: Variable[] = [
    {
      name: 'Charges',
      display: false,
      reducerField: DisplayField.CollectionsCharge,
      dispatchAction(display: boolean): AppAction {
        return collectionsChargeDisplayedChangedTo(display);
      }
    },
    {
      name: 'Expected Payments',
      display: false,
      reducerField: DisplayField.ExpectedPayments,
      dispatchAction(display: boolean): AppAction {
        return expectedPaymentsDisplayedChangedTo(display);
      }
    }
  ];
  tabLevel: LevelType = LevelType.none;
  columnsMultiLevel: any[] = columnsForPayerByMultiLevelCollections.slice();
  columns: any[] = columnsForPayerCollections.slice();
  displayedColumns: any[] = columnsForPayerCollections.slice().filter(col => col.isDefault || col.primaryColumn);
  reducerAction: (multiLevelByNodePathPayerCollectionsColumns: BaseColumn[]) => AppAction =
    multiLevelByNodePathPayerCollectionsColumnsChangedTo;
  @Output() levelChange = new EventEmitter();
  @Input() isMultiLevel = true;
  @Input() activeVarianceToggle: boolean;


  private static isAPayerByMultilevelZeroSuppressible(entry: PayerByMultiLevelCollectionsByNodePath): boolean {
    return entry.chargeAmount === 0 && entry.primaryAndOtherPayerContractuals === 0 && entry.charityCareAmount === 0
      && entry.discountAmount === 0 && entry.expectedPayments === 0 && entry.primaryAndOtherInsurancePayments === 0 &&
      entry.patientPaymentAmount === 0 && entry.totalPayments === 0 && entry.controllableAllowance === 0 &&
      entry.smallBalanceWriteOffs === 0 && entry.patientRelatedBadDebt === 0 && entry.outstandingAR === 0;
  }

  constructor(private ngRedux: NgRedux<IAppState>, private _changeDetectorRef: ChangeDetectorRef, private router: Router,
              @Inject(AnalyticsServiceToken) private readonly analyticsService: AnalyticsService) {
  }

  ngOnInit() {
    this.ngRedux.dispatch(payerByLevelCollectionsPayerColumnsChangedTo([]));
    this.subscription = combineLatest([
      this.payerCollectionsData$.pipe(distinctUntilChanged((data1, data2) => _.isEqual(data1, data2))),
      this.payerByMultiLevelCollectionsData$.pipe(distinctUntilChanged((data1, data2) => _.isEqual(data1, data2))),
      this.payerByLevelPayerColumns$.pipe(distinctUntilChanged((a, b) => _.isEqual(a, b))),
      this.payerByLevelStaticColumns$.pipe(distinctUntilChanged((a, b) => _.isEqual(a, b))),
      this.benchmarkType$, this.zeroSuppression$,
      this.displayedPayerCollectionsColumns$.pipe(distinctUntilChanged((a, b) => _.isEqual(a, b)))
    ]).subscribe(
      ([payerCollectionsData, payerByMultiLevelCollectionsData, payerByLevelPayerColumns,
         payerByLevelStaticColumns, benchmark, zeroSuppression, displayedPayerCollectionsColumns]:
         [PayerCollections[], PayerMatchedCollectionsMultiLevelNodePathData,
           BaseColumn[], BaseColumn[],
           BenchmarkType, boolean, BaseColumn[]]) => {
        this.isZeroSuppressed = zeroSuppression;
        this.benchmarkType = benchmark;
        const payerType = this.ngRedux.getState().filters.payerType;
        switch (payerType) {
          case PayerType.ALL:
            this.payerLevel = 'Payer Category';
            break;
          case PayerType.CATEGORY:
            this.payerLevel = 'National Payer';
            break;
          case PayerType.NATIONAL:
          case PayerType.MEMBER:
          default:
            this.payerLevel = 'Member Payer';
            break;
        }
        this.payerByLevelPayerColumns = payerByLevelPayerColumns;

        const {featureToggleSettings, userProfile} = this.ngRedux.getState().data;
        this.payerCollectionsData = payerCollectionsData;

        this.providerColumns[7] = createNCRBenchmarkColumnFor(benchmark);
        this.providerColumns[8] = createCollectionsVarianceColumnFor(benchmark);
        this.specialtyColumns[6] = createNCRBenchmarkColumnFor(benchmark);
        this.specialtyColumns[7] = createCollectionsVarianceColumnFor(benchmark);
        this.departmentColumns[5] = createNCRBenchmarkColumnFor(benchmark);
        this.departmentColumns[6] = createCollectionsVarianceColumnFor(benchmark);

        this.payerByMultiLevelCollectionsData = payerByMultiLevelCollectionsData;
        this.departmentPayerCollectionsData = payerByMultiLevelCollectionsData.departmentCollections;
        this.specialtyPayerCollectionsData = payerByMultiLevelCollectionsData.specialtyCollections;
        this.providerPayerCollectionsData = this.isZeroSuppressed ? payerByMultiLevelCollectionsData.providerCollections
            .filter(entry => !PayerCollectionsMultilevelComponent.isAPayerByMultilevelZeroSuppressible(entry)).slice() :
          payerByMultiLevelCollectionsData.providerCollections.slice();
        this.howManyProvidersSuppressed = payerByMultiLevelCollectionsData.providerCollections.length -
          this.providerPayerCollectionsData.length;

        this.originalByLevelColumns = columnsForPayerByMultiLevelCollections.slice();
        this.showProgressBar = this.getShowProgressBarStatus();
        this.showProgressBarMultiLevel = this.getShowProgressBarStatusMultiLevel();

        const state = this.ngRedux.getState();
        this.nodePath = state.filters.nodePath;
        const isCustom: boolean = state.display.isCustom;
        const multipleProviders = state.display.multipleProviders;
        const multipleSpecialties = state.display.multipleSpecialties;
        const multipleDepartments = state.display.multipleDepartments;

        this.level = getLevel(isCustom, this.nodePath, multipleProviders, multipleSpecialties, multipleDepartments);
        this.defaultSortColumn = 'netCollectionRate';
        this.isProvider = state.display.isProviderSelected;
        this.columns[15] = createPayerNCRBenchmarkColumnFor(benchmark);
        if (benchmark === BenchmarkType.Mean) {
          benchmark = BenchmarkType.Percentile50th;
        }
        this.columns[16] = createCollectionsVarianceColumnFor(benchmark);
        this.columns = this.columns.slice();
        this.updateColumnFilter(displayedPayerCollectionsColumns);
        this.canHideScrollable = canHide(FeatureToggleEntries.SCROLLABLE_PAYERS, featureToggleSettings, userProfile);
        this.canHideDenials = canHide(FeatureToggleEntries.DENIALS_MODAL, featureToggleSettings, userProfile);
        switch (this.chosenTab) {
          case MultilevelTabCollections.BY_PROVIDER:
            this.columnsMultiLevel = _.cloneDeep(this.providerColumns);
            break;
          case MultilevelTabCollections.BY_SPECIALTY:
            this.columnsMultiLevel = _.cloneDeep(this.specialtyColumns);
            break;
          case MultilevelTabCollections.BY_DEPARTMENT:
            this.columnsMultiLevel = _.cloneDeep(this.departmentColumns);
            break;
        }


        this.displayedDepartmentColumns = this.departmentColumns.slice();
        this.displayedSpecialtyColumns = this.specialtyColumns.slice();
        this.displayedProviderColumns = this.providerColumns.slice();

        [this.departmentColumns, this.specialtyColumns, this.providerColumns].forEach(multiLevelCol => {
          multiLevelCol[0].primaryColumn = true;
          createNCRBenchmarkColumnFor(this.benchmarkType);
        });

        this.originalByLevelColumns[5] = createNCRBenchmarkColumnFor(benchmark);
        this.originalByLevelColumns[6] = createCollectionsVarianceColumnFor(benchmark);
        this.payerStaticColumns = payerByLevelStaticColumns;
        const staticColumnDefs = this.payerStaticColumns.map(col => this.getUpdatedColumnDef(col, this.benchmarkType));

        this.getMultiLevelPayerScrollableColumns();

        const staticColumns: DataTableColumns[] = this.originalByLevelColumns
          .filter(ogColumn => ogColumn.primaryColumn || staticColumnDefs.includes(ogColumn.columnDef));

        const primaryColumn = staticColumns.find(col => col.primaryColumn);
        if (this.level && primaryColumn) {
          primaryColumn.header = this.level.split(' ')[1];
        }

        this.displayedByLevelColumns = [...staticColumns];
        if (this.displayedByLevelColumns.length > 7) {
          this.hasPayers = true;
        }
        this._changeDetectorRef.detectChanges();
      });

    this.columnSubscription = this.multiLevelByNodePathPayerCollectionsColumns$
      .pipe(distinctUntilChanged((data1, data2) => _.isEqual(data1, data2)))
      .subscribe(displayedColumns => {
        this.displayedDepartmentColumns =
          this.updateMultiLevelColumnFilter(displayedColumns, this.departmentColumns);
        this.displayedSpecialtyColumns =
          this.updateMultiLevelColumnFilter(displayedColumns, this.specialtyColumns);
        displayedColumns = displayedColumns.concat(
          this.providerColumns.filter(col => col.columnType === ColumnType.OPEN_WINDOW));
        this.displayedProviderColumns =
          this.updateMultiLevelColumnFilter(displayedColumns, this.providerColumns);
      });

    switch (this.ngRedux.getState().display.collectionsChosenTab) {
      case MultilevelTabCollections.BY_DEPARTMENT:
        this.chosenTab = MultilevelTabCollections.BY_DEPARTMENT;
        break;
      case MultilevelTabCollections.BY_SPECIALTY:
        this.chosenTab = MultilevelTabCollections.BY_SPECIALTY;
        break;
      case MultilevelTabCollections.BY_PROVIDER:
        this.chosenTab = MultilevelTabCollections.BY_PROVIDER;
        break;
      default:
        this.chosenTab = MultilevelTabCollections.BY_DEPARTMENT;
        break;
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.columnSubscription?.unsubscribe();
    this._changeDetectorRef.detach();
  }

  levelSpecificHandleSortChange = (payerCollectionsEntries: PayerByMultiLevelCollectionsByNodePath[]) => {
    this.ngRedux.dispatch(multilevelPayerCollectionsChangedTo({
      ...this.ngRedux.getState().data.matchedCollectionsByPayerByMultiLevelByNodePathData,
      departmentCollections: (this.chosenTab === MultilevelTabCollections.BY_DEPARTMENT ? payerCollectionsEntries
        : this.ngRedux.getState().data.matchedCollectionsByPayerByMultiLevelByNodePathData.departmentCollections),
      specialtyCollections: (this.chosenTab === MultilevelTabCollections.BY_SPECIALTY ? payerCollectionsEntries
        : this.ngRedux.getState().data.matchedCollectionsByPayerByMultiLevelByNodePathData.specialtyCollections),
      providerCollections: (this.chosenTab === MultilevelTabCollections.BY_PROVIDER ? payerCollectionsEntries
        : this.ngRedux.getState().data.matchedCollectionsByPayerByMultiLevelByNodePathData.providerCollections)
    }));
  };

  getMultiLevelPayerScrollableColumns(): void {

    let payerColumns: DataTableColumns[] = this.payerByLevelPayerColumns.map(payerColumn => ({
      columnDef: payerColumn.columnDef,
      header: payerColumn.header,
      dataName: (row: CollectionsByPayerGroupedByLevel) => `${row[payerColumn.columnDef] || '-'}`,
      columnType: ColumnType.PAYER
    }));

    payerColumns = payerColumns.filter(col => col.columnDef !== '');
    if (payerColumns.length >= 1) {
      payerColumns[0].group = 'group-first';
    }

    // @ts-ignore
    const staticColumnDefs = this.payerStaticColumns.map(col => this.getUpdatedColumnDef(col, this.benchmarkType));

    const staticColumns: DataTableColumns[] = this.originalByLevelColumns
      .filter(ogColumn => ogColumn.primaryColumn || staticColumnDefs.includes(ogColumn.columnDef));

    const primaryColumn = staticColumns.find(col => col.primaryColumn);
    if (this.level && primaryColumn) {
      primaryColumn.header = this.level.split(' ')[1];
    }

    this.scrollableMultiLevelColumns = payerColumns;

    this._changeDetectorRef.detectChanges();
    this.openWindowColumns = !this.canHideDenials ? [{
      columnDef: 'viewDenials',
      header: '',
      dataName: () => 'View Denials',
      isDefault: true,
      class: () => 'viewDenials',
      showDenials: true,
      columnType: ColumnType.OPEN_WINDOW,
      nodePath: (row: PayerByMultiLevelCollectionsByNodePath) => this.calculateDenialsNodePath(row, this.chosenTab),
      nodeName: (row: PayerByMultiLevelCollectionsByNodePath) => this.chosenTab ===
      MultilevelTabCollections.BY_PROVIDER ? row.departmentNodeName + ', ' + row.specialtyNodeName + ', ' +
        row.providerNodeName : row.departmentNodeName + ', ' + row.specialtyNodeName
    }] : [];
    this._changeDetectorRef.detectChanges();
  }

  calculateDenialsNodePath(row: PayerByMultiLevelCollectionsByNodePath, chosenTab: MultilevelTabCollections): string {
    let result;
    if (chosenTab === MultilevelTabCollections.BY_PROVIDER || chosenTab === MultilevelTabCollections.BY_PAYER_BY_PROVIDER) {
      result = row.providerNodePath;
    } else if (chosenTab === MultilevelTabCollections.BY_SPECIALTY || chosenTab === MultilevelTabCollections.BY_PAYER_BY_SPECIALTY) {
      result = this.getNodePathCompatibleWithFilterCriteria(row.specialtyNodePath, this.nodePath);
    } else {
      result = this.getNodePathCompatibleWithFilterCriteria(row.departmentNodePath, this.nodePath);
    }
    return result;
  }

  // Filter Node Path:
  //  1. Single Department / Multiple Departments
  //  2. Single Specialty / Multiple Specialties
  //  3. Single Provider / Multiple providers
  private getNodePathCompatibleWithFilterCriteria(originalNodePath: string, filtersNodePath: string): string {
    const compatibleNodePaths = filtersNodePath.split('|').filter(path =>
      path.includes(originalNodePath));
    return compatibleNodePaths.length === 0 ? originalNodePath : compatibleNodePaths.join('|');
  }

  getUpdatedColumnDef(displayedColumn: BaseColumn, benchmarkType: BenchmarkType): string {
    switch (displayedColumn.columnType) {
      case ColumnType.BENCHMARK:
        return createNCRBenchmarkColumnFor(benchmarkType).columnDef;
      case ColumnType.VARIANCE:
        return createCollectionsVarianceColumnFor(benchmarkType).columnDef;
      default:
        return displayedColumn.columnDef;
    }
  }

  updateMultiLevelColumnFilter(displayedColumns: BaseColumn[], tableColumns: DataTableColumns[]) {
    const displayedColumnDefs: string[] = displayedColumns.map(col => {
      switch (col.columnType) {
        case ColumnType.BENCHMARK:
          return createNCRBenchmarkColumnFor(this.benchmarkType).columnDef;
        case ColumnType.VARIANCE:
          return createCollectionsVarianceColumnFor(this.benchmarkType).columnDef;
        default:
          return col.columnDef;
      }
    });


    return tableColumns.filter(col => col.primaryColumn || displayedColumnDefs.includes(col.columnDef)).slice();
  }

  getShowProgressBarStatus(): boolean {
    return _.isEqual(this.payerCollectionsData, INITIAL_STATE.data.payerCollectionsData.payerMatchedCollections);
  }

  getShowProgressBarStatusMultiLevel(): boolean {
    return _.isEqual(this.payerByMultiLevelCollectionsData,
      INITIAL_STATE.data.matchedCollectionsByPayerByMultiLevelByNodePathData);
  }

  whenSortChanged = (payerCollectionsData: any) => {
    this.ngRedux.dispatch(payerCollectionsDataChangedTo({payerMatchedCollections: payerCollectionsData}));
  };

  payerSelectionCallBack = (payerDrilldownCriteria: PayerDrilldownCriteria) => {
    const originalFilters = this.ngRedux.getState().filters;
    const payerType = originalFilters.payerType;
    const criteriaType = payerDrilldownCriteria.type;
    if (payerType !== criteriaType) {
      this.ngRedux.dispatch(filterCriteriaChangedTo({
        ...originalFilters,
        payerCategory: payerDrilldownCriteria.category,
        payerType: payerDrilldownCriteria.type,
        payerKey: payerDrilldownCriteria.key,
        nationalPayerDescription: criteriaType === PayerType.NATIONAL ? payerDrilldownCriteria.description
          : originalFilters.nationalPayerDescription,
        nationalPayerKey: criteriaType === PayerType.NATIONAL ? payerDrilldownCriteria.key
          : originalFilters.nationalPayerKey,
        memberPayerDescription: criteriaType === PayerType.MEMBER ? payerDrilldownCriteria.description
          : originalFilters.memberPayerDescription,
        memberPayerKey: criteriaType === PayerType.MEMBER ? payerDrilldownCriteria.key
          : originalFilters.memberPayerKey, chosenByUser: true
      }));
    }
  };

  chooseTab(tab: MultilevelTabCollections): void {
    if (this.chosenTab !== tab) {
      this.ngRedux.dispatch(payerByLevelCollectionsPayerColumnsChangedTo([]));
    }
    this.chosenTab = tab;
    this._changeDetectorRef.detectChanges();
  }

  updateColumnFilter(displayedColumns: BaseColumn[]) {
    const displayedColumnDefs: string[] = displayedColumns.map(col => this.getUpdatedColumnDef(col, this.benchmarkType));

    this.displayedColumns = this.columns.filter(col => col.primaryColumn || displayedColumnDefs.includes(col.columnDef));
  }
}
